import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import GiftCards from './giftCards/containers/GiftCards';
import withNewDesignStyles from '../common/hoc/withNewDesignStyles';
import Layout from './components/Layout';
import Sale from './sale/Sale';
import CustomCharge from './customCharge/CustomCharge';
import RegisterSummary from './summary';
import CashRegister from './cashRegister/containers/CashRegisterContainer';
import WebreaderProcessor from './webReader/WebreaderProcessor';
import * as hooks from '../auth/routerHooks';
import { containerApp } from '../../main';
import { FS_FEATURES } from '../../modules/infra/observability/fullstory';

const Routes = store => (
  <Route
    path="register"
    onEnter={(...args) => {
      hooks.initFullstoryFeature(FS_FEATURES.REGISTER)();
      return hooks.requireRegisterViewPermission(store)(...args);
    }}
    onLeave={hooks.handleRegisterOnLeave(store)}
  >
    <Route component={withNewDesignStyles(Layout)}>
      <IndexRoute component={Sale} />
      <Route
        path="custom-charge"
        component={CustomCharge}
        onEnter={hooks.requireCustomChargeViewPermission(store)}
        display-if={!containerApp.isActive()}
      />
      <Route
        path="summary" component={RegisterSummary} onEnter={hooks.requireDailySummaryViewPermission(store)}
        display-if={!containerApp.isActive()}
      />
      <Route
        path="cash-register" component={CashRegister} onEnter={hooks.requireCashRegisterViewPermission(store)}
        display-if={!containerApp.isActive()}
      />
      <Route
        path="gift-cards" component={GiftCards} onEnter={hooks.requireGiftCardSellerConditions(store)}
      />
      <Route path="webreader-processor" component={WebreaderProcessor} />
    </Route>
  </Route>
);

export default Routes;
